import bdServices from '../../bd-services'

var FormData = require('form-data')
const currentUrl = window.location.hostname

const accesos_tpaServices = {}

accesos_tpaServices.getAccesos = async function (fecha) {
  const data = await bdServices(`/servidores/tpa/sca/accesos/getAccesos.php?fecha=${fecha}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

accesos_tpaServices.getAccesos_estado = async function (fecha, estado) {
  const data = await bdServices(`/servidores/tpa/sca/accesos/getAccesos_estado.php?fecha=${fecha}&estado=${estado}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

accesos_tpaServices.getAccesos_autotanques = async function () {
  const data = await bdServices(`/servidores/tpa/sca/accesos/getAccesos_Autotanques.php?`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

accesos_tpaServices.registrarAcceso = async function (fechaReg, fechaJornada, pg, embarque, idUsuario, usuario, claveAcceso ) {

  let formData = new FormData()
  formData.append('fechaLlegada', fechaReg)
  formData.append('fechaReporte', fechaJornada)
  formData.append('pg', pg)
  formData.append('embarque', embarque)
  formData.append('idUsuario', idUsuario)
  formData.append('usuario', usuario)
  formData.append('claveAcceso', claveAcceso)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/addAcceso.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso = async function (id, pg ) {

  let formData = new FormData()
  formData.append('id', id)
  formData.append('pg', pg)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAcceso_Inicio.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_Programa = async function (id, programa ) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('programa', programa)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_Programa.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_IDPrograma = async function (id, idNomcar ) {
  let formData = new FormData()
  formData.append('id', id)
  formData.append('idNomcar', idNomcar)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_IDPrograma.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}


accesos_tpaServices.updateAcceso_PesoE = async function (claveAcceso, peso ) {

  let formData = new FormData()
  formData.append('ca', claveAcceso)
  formData.append('peso', peso)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_PesoE.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_PesoS = async function (claveAcceso, peso ) {

  let formData = new FormData()
  formData.append('ca', claveAcceso)
  formData.append('peso', peso)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_PesoS.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_Magnatel = async function (id, magnatel ) {

  let formData = new FormData()
  formData.append('id', id)
  formData.append('magnatel', magnatel)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_Magnatel.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_Presion = async function (id, presion ) {

  let formData = new FormData()
  formData.append('id', id)
  formData.append('presion', presion)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_Presion.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.updateAcceso_Subgrupo = async function (claveAcceso, subgrupo ) {

  let formData = new FormData()
  formData.append('cA', claveAcceso)
  formData.append('subgrupo', subgrupo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/updateAccesos_Subgrupo.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.addAcceso_Sello = async function (id, sello, tipo) {

  let formData = new FormData()
  formData.append('id', id)
  formData.append('sello', sello)
  formData.append('tipo', tipo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/addAcceso_Sello.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.deleteAcceso_Sello = async function (id) {

  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/deleteAcceso_Sello.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.deleteAcceso = async function (id) {

  let formData = new FormData()
  formData.append('id', id)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/deleteAcceso.php'
  }

  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.deleteAutotanque = async function(idTanque, estado) {
  let formData = new FormData()
  formData.append('id', idTanque)
  formData.append('estado', estado)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/deleteAccesos.php'
  }
  const data = await bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
  return data
}

accesos_tpaServices.addEdicion = async function (idEmbarque, fecha, usuario, cambios, motivos) {
  let formData = new FormData()
  formData.append('idEmbarque', idEmbarque)
  formData.append('fecha', fecha)
  formData.append('usuario', usuario)
  formData.append('cambios', cambios)
  formData.append('motivos', motivos)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/addMovimientoAccesos.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

accesos_tpaServices.registrarAcceso_clave = async function (claveAcceso) {
  let formData = new FormData()
  formData.append('claveAcceso', claveAcceso)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/tpa/sca/accesos/registrarAcceso.php'
  }
    const data = await bdServices(options)
      .then(res => res.data)
      .catch((err) => {
        console.error(err)
      })
    return data
}

accesos_tpaServices.getAccesosByPg = async function (palabra) {
  const data = await bdServices(`/servidores/tpa/sca/accesos/getAccesosByPg.php?pg=${palabra}`)
    .then(res => res.data)
    .catch(e => console.log(e))
  return data
}

export default accesos_tpaServices


// WEBPACK FOOTER //
// ./src/services/sca/accesos/accesosTPA.js